"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { useParams, useSearchParams } from "next/navigation";
import { useEffect, useRef } from "react";
import type { UserPageTabConfig, UserPageTabKey } from "./userTabs.config";
interface UserPageTabProps {
  readonly tab: UserPageTabConfig;
  readonly parentRef: React.RefObject<HTMLDivElement | null>;
  readonly activeTabId: UserPageTabKey;
}
export default function UserPageTab(t0) {
  const $ = _c(24);
  const {
    tab,
    parentRef,
    activeTabId
  } = t0;
  const params = useParams();
  const searchParams = useSearchParams();
  let t1;
  if ($[0] !== params?.user) {
    t1 = params?.user?.toString();
    $[0] = params?.user;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleOrWallet = t1;
  const path = `/${handleOrWallet}/${tab.route}`;
  const isActive = tab.id === activeTabId;
  const classes = isActive ? "tw-flex tw-items-center tw-border-primary-400 tw-border-solid tw-border-x-0 tw-border-t-0 tw-text-iron-100 tw-whitespace-nowrap tw-border-b-2 tw-font-semibold tw-py-4 tw-px-1" : "tw-flex tw-items-center tw-border-transparent tw-text-iron-500 hover:tw-border-gray-300 hover:tw-text-iron-100 tw-whitespace-nowrap tw-border-b-2 tw-py-4 tw-px-1 tw-transition tw-duration-300 tw-ease-out";
  const ref = useRef(null);
  let t2;
  if ($[2] !== parentRef) {
    t2 = () => {
      if (!parentRef.current || !ref.current) {
        return true;
      }
      const parentRect = parentRef.current.getBoundingClientRect();
      const rect = ref.current.getBoundingClientRect();
      const parentRight = parentRect.right;
      const parentLeft = parentRect.left;
      const elementRight = rect.right;
      const elementLeft = rect.left;
      return elementRight <= parentRight && elementLeft >= parentLeft;
    };
    $[2] = parentRef;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const isVisibleInViewportSide = t2;
  let t3;
  if ($[4] !== isActive || $[5] !== isVisibleInViewportSide) {
    t3 = () => {
      if (ref.current && isActive && !isVisibleInViewportSide()) {
        ref.current.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center"
        });
      }
    };
    $[4] = isActive;
    $[5] = isVisibleInViewportSide;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== isActive) {
    t4 = [isActive];
    $[7] = isActive;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  useEffect(t3, t4);
  let t5;
  if ($[9] !== searchParams) {
    t5 = searchParams?.get("address") ? {
      address: searchParams.get("address")
    } : {};
    $[9] = searchParams;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== path || $[12] !== t5) {
    t6 = {
      pathname: path,
      query: t5
    };
    $[11] = path;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const t7 = `${isActive ? "tw-pointer-events-none" : ""}  tw-no-underline tw-leading-4 tw-p-0 tw-text-base tw-font-semibold`;
  let t8;
  if ($[14] !== tab.badge) {
    t8 = tab.badge && <span className="tw-ml-1 tw-rounded-full tw-bg-primary-300/20 tw-px-1.5 tw-py-0.5 tw-text-[0.625rem] tw-font-bold tw-uppercase tw-leading-none tw-text-primary-400 tw-tracking-wider">{tab.badge}</span>;
    $[14] = tab.badge;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== classes || $[17] !== t8 || $[18] !== tab.title) {
    t9 = <div className={classes}>{tab.title}{t8}</div>;
    $[16] = classes;
    $[17] = t8;
    $[18] = tab.title;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t6 || $[21] !== t7 || $[22] !== t9) {
    t10 = <Link ref={ref} href={t6} className={t7}>{t9}</Link>;
    $[20] = t6;
    $[21] = t7;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
}